import { IPaymentCompletedResponse } from "../payments.typings";

export const hostedState = {
	hostedCapture: {
		applyStateLoading: {
			errorMessage: "",
			hasError: false,
			loading: false,
			started: false,
			success: false,
		},
		paymentResponse: {} as IPaymentCompletedResponse,
	},
};

const hostedReducer = () => {
	return {
		postHostedCaptureStart: (state, { payload }) => {
			return {
				...state,
				hostedCapture: {
					...state.hostedCapture,
					applyStateLoading: {
						started: true,
						loading: true,
						success: false,
						hasError: false,
						errorMessage: "",
					},
				},
			};
		},
		postHostedCaptureComplete: (state, { payload }) => {
			return {
				...state,
				hostedCapture: {
					...state.hostedCapture,
					applyStateLoading: {
						...state.hostedCapture.applyStateLoading,
						started: true,
						loading: false,
						success: true,
					},
					paymentResponse: payload.data.results,
				},
			};
		},
		postHostedCaptureFail: (state, { payload }) => {
			return {
				...state,
				hostedCapture: {
					...state.hostedCapture,
					applyStateLoading: {
						...state.hostedCapture.applyStateLoading,
						started: true,
						loading: false,
						success: false,
						hasError: true,
						errorMessage: payload,
					},
				},
			};
		},
		resetHostedCaptureState: (state) => {
			return {
				...state,
				hostedCapture: {
					applyStateLoading: {
						started: false,
						loading: false,
						success: false,
						hasError: false,
						errorMessage: "",
					},
					paymentResponse: {} as IPaymentCompletedResponse,
				},
			};
		},
	};
};
export default hostedReducer;
